import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fetchMyTeamSummary } from '../orgChartApi';

// Spec §4 — yönetilen alt dalı olan kullanıcının özet şeridi: yönetilen / boş / ayrılan / açık talep. Alt dalı olmayan
// (çalışanların çoğu) ve yükleme hatası: hiç çizilmez (sayı uydurulmaz).

const Strip = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-family: 'Nunito Sans', sans-serif;
`;

const Chip = styled.span`
  font-size: 12px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 12px;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;

export default function TeamSummaryBar({ reloadKey = 0 }) {
  const { t } = useTranslation();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchMyTeamSummary().then((result) => {
      if (alive && result.state === 'ok') setSummary(result.data);
    });
    return () => { alive = false; };
  }, [reloadKey]);

  if (!summary?.hasManagedSubtree) return null;
  return (
    <Strip data-testid="team-summary">
      <Chip $bg="#EFF6FF" $color="#2563EB">{t('orgChart.teamSummary.managed', { count: summary.managedCount })}</Chip>
      <Chip $bg="#F0F2F5" $color="#6B7280">{t('orgChart.teamSummary.vacant', { count: summary.vacantCount })}</Chip>
      <Chip $bg="#FEF3C7" $color="#B45309">{t('orgChart.teamSummary.leaving', { count: summary.leavingCount })}</Chip>
      <Chip $bg="#F0FDF4" $color="#16A34A">{t('orgChart.teamSummary.openRequisitions', { count: summary.openRequisitionCount })}</Chip>
    </Strip>
  );
}
